<!--
 * @FilePath: \lxsk-official\src\views\NotFound.vue
 * @Description:  
 * @Author: wys
 * @Date: 2025-04-27 14:05:14
 * @LastEditors: wys
 * @LastEditTime: 2025-04-27 14:16:33
-->
<template>
  <div id="not_found">
    <img src="~@/assets/404.png" alt="">
    <div>
      <h3>抱歉，当前页面无法访问</h3>
      <p>网址错误或不存在。请检查您的网址是否正确</p>
      <div class="btn">
        <button @click="$router.replace('/')">回到首页</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style lang="less" scoped>
#not_found {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F1F2F5;

  img {
    width: 346px;
    height: 304px;
    margin-right: 60px;
  }

  h3 {
    height: 42px;
    font-weight: 500;
    font-size: 30px;
    color: #262626;
    line-height: 42px;
  }

  p {
    height: 28px;
    font-size: 20px;
    color: #666666;
    line-height: 28px;
    letter-spacing: 1px;
    margin-top: 5px;
    margin-bottom: 14px;
  }

  .btn {

    button {
      display: inline-block;
      background-color: #C70009;
      color: #fff;
      line-height: 40px;
      text-align: center;
      border-radius: 2px;
      box-sizing: border-box;
      cursor: pointer;
      border: none;
      width: 120px;
      height: 40px;
      background: #C70009;
      border-radius: 20px;
    }
  }
}
</style>
